import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://backupmanagerbackend.amygbserver.in';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

//Auth
export const login = (data) => api.post(`/api/auth/login`, data);


// Servers
export const getServers = () => api.get('/api/servers');
export const getServer = (id) => api.get(`/api/servers/${id}`);
export const createServer = (data) => api.post('/api/servers', data);
export const updateServer = (id, data) => api.put(`/api/servers/${id}`, data);
export const deleteServer = (id) => api.delete(`/api/servers/${id}`);

// Apps
export const getAppsByServer = (serverId) => api.get(`/api/servers/${serverId}/apps`);
export const createApp = (data) => api.post('/api/apps', data);
export const updateApp = (id, data) => api.put(`/api/apps/${id}`, data);
export const deleteApp = (id) => api.delete(`/api/apps/${id}`);

// Jobs
export const triggerBackup = (target_type, target_id) =>
  api.post('/api/backup', { target_type, target_id });

export const triggerDeploy = (target_type, target_id, new_server_ip, backup_to_restore) =>
  api.post('/api/deploy', { target_type, target_id, new_server_ip, backup_to_restore });

export const getJobs = (limit) => api.get('/api/jobs', { params: { limit } });
export const getJob = (id) => api.get(`/api/jobs/${id}`);
export const cancelJob = (id, cancel_type) =>
  api.post(`/api/jobs/${id}/cancel`, { cancel_type });

export const getBackupDetails = (jobId) =>
  api.get(`/api/jobs/${jobId}/backup`);

export const getBackupHistory = (target_type, target_id, limit = 20) =>
  api.get('/api/backup/history', { params: { target_type, target_id, limit } });

export const getLastBackup = (target_type, target_id) =>
  api.get('/api/backup/last', { params: { target_type, target_id } });

// Settings
export const getSetting = (key) => api.get(`/api/settings/${key}`);
export const setSetting = (key, value, encrypted = true) =>
  api.post('/api/settings', { key, value, encrypted });

// Health
export const getHealth = () => api.get('/health');

export default api;
